import { render, staticRenderFns } from "./FnfLeagueGameView.vue?vue&type=template&id=008c2e46&"
import script from "./FnfLeagueGameView.vue?vue&type=script&lang=js&"
export * from "./FnfLeagueGameView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports